var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDownActiveIcon = function SvgThumbsDownActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.279 1.559.024 9.809a1.85 1.85 0 0 0 .323 1.374 1.82 1.82 0 0 0 1.196.734h5.45v3.666c0 .73.286 1.43.797 1.945a2.71 2.71 0 0 0 1.927.805l3.616-8.25V0H3.103a1.8 1.8 0 0 0-1.202.434 1.84 1.84 0 0 0-.622 1.125M15 0v10h1.697a1.58 1.58 0 0 0 1.158-.538c.306-.34.478-.8.478-1.279V1.817c0-.48-.172-.939-.478-1.279A1.58 1.58 0 0 0 16.697 0z"
  })));
};
export default SvgThumbsDownActiveIcon;